<template>
  <ConfirmationDialog
    v-if="prompt"
    :dialog="true"
    icon="Add_Icon_gray.svg"
    confirmLabel="Yes"
    cancelLabel="No"
    @confirm="onYes"
    @cancel="onNo"
  >
    <template #title>Appoint yourself as Architect?</template>
    <template #content>
      <span data-testid="self-appoint-text">{{ SELF_APPOINT_PROMPT_TEXT }}</span>
    </template>
  </ConfirmationDialog>
</template>

<script setup>
import { computed, getCurrentInstance } from "vue";
import ConfirmationDialog from "@components/ResponsibilitiesPicker/ConfirmationDialog.vue";
import { SELF_APPOINT_PROMPT_TEXT } from "@components/utils/appointedBadge";
import { getApiErrorDetail } from "@components/utils/apiErrorDetail";
import { useSelfAppointPromptStore } from "@/store/pinia/selfAppointPrompt";

const { proxy } = getCurrentInstance();
const promptStore = useSelfAppointPromptStore();
const prompt = computed(() => promptStore.current);

function onNo() {
  promptStore.dismissCurrent();
}

async function onYes() {
  try {
    await promptStore.confirmCurrent();
    proxy.$notifications?.success("Badge appointed successfully");
  } catch (e) {
    proxy.$notifications?.error(
      getApiErrorDetail(e) || "Could not appoint the badge. Please try again."
    );
  }
}
</script>
